"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = (s, ns = 'legal') => s.replace(`${ns}.`, '');
//# sourceMappingURL=removeNamespace.js.map